import { Checkbox, Stack } from "@mui/material";
import { type Ref, forwardRef } from "react";
import type { GroupProps } from "react-virtuoso";
import { VirtuosoGroup } from "../GroupedVirtualized/Group";
import { useGroupedVirtualizedSelectContext } from "./context";
import { CheckStatus } from "./logics";

export const VirtuosoSelectGroup = forwardRef(function VirtuosoSelectGroup(
  { style, children, ...props }: GroupProps,
  ref?: Ref<HTMLDivElement>
) {
  const { hideCheckboxes, slotProps, getGroupCheckStatus, addGroup, deleteGroup } =
    useGroupedVirtualizedSelectContext();
  const groupIndex = props["data-item-index"];
  const groupCheckStatus = getGroupCheckStatus(groupIndex);

  return (
    <Stack
      {...props}
      direction="row"
      {...slotProps?.selectGroup}
      style={{ ...style, zIndex: 2 }}
      ref={ref}
      sx={{
        alignItems: "center",
      }}
    >
      <Checkbox
        {...slotProps?.selectGroupCheckbox}
        sx={{ ...(hideCheckboxes && { display: "none" }), ...slotProps?.selectGroupCheckbox?.sx }}
        checked={groupCheckStatus === CheckStatus.CHECKED}
        indeterminate={groupCheckStatus === CheckStatus.INDETERMINATE}
        onChange={(evt) => (evt.target.checked ? addGroup(groupIndex) : deleteGroup(groupIndex))}
      />
      <VirtuosoGroup {...props}>{children}</VirtuosoGroup>
    </Stack>
  );
});
